export default __webpack_public_path__ + "static/media/logo.262a096f.png";